import React from "react";
import { Button } from "../ui/button";
import Image from "../Tags/Image";

export default function BulkPhoneEmailButton({ phonesLength = "", emailsLength = "", isLoading = false }) {
  return (
    <Button variant="outline" className="px-3">
      <span className="flex space-x-3">
        <span className={`inline-flex items-center space-x-2 ${!phonesLength && "opacity-50"}`}>
          <Image className="no-invert" src="/images/ext/phone2.svg" alt="Phone" />
          {(phonesLength || phonesLength == "0") && <span>{phonesLength}</span>}
        </span>
        <span className="w-[1px] bg-gray-300"></span>
        <span className={`inline-flex items-center space-x-2 ${!emailsLength && "opacity-50"}`}>
          <Image className="no-invert" src="/images/ext/email.svg" alt="Email" width={20} height={20} />
          {(emailsLength || emailsLength == "0") && <span>{emailsLength}</span>}
        </span>
      </span>
    </Button>
  );
}
